import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const ClothesClassification = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    const [idItem, setIdItem] = useState(null);
    const [dsClassification, setDsClassification] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [clothesIdSelected, setClothesIdSelected] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idItem, setter: setIdItem },
        { name: "dsClassification", value: dsClassification, setter: setDsClassification },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setClothesIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, isActiveFilter]);

    useEffect(() => {
        // A grid é recarregada após salvar (post/put); selecionar uma linha só busca o detalhe
        if ((!clothesIdSelected || clothesIdSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!clothesIdSelected || clothesIdSelected.length > 1) {
            setClothesIdSelected([])
        }
    }, [clothesIdSelected, updating]);


    useEffect(() => {
        if (clothesIdSelected && clothesIdSelected.length === 1) {
            fetchDataDetail(clothesIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [clothesIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {
        const parameters = { onlyActive: isActiveFilter }
        const items = await ExecuteAxios.api('get', `/classification/get-classification-grid/`, { params: parameters });
        setRecordsItemByUserId(items)
        RemoveIdsNotFound.remove(items, setClothesIdSelected, clothesIdSelected)
    }

    const fetchDataDetail = async (clothesIdSelected) => {
        const parameters = { id: clothesIdSelected ? clothesIdSelected : 0 }
        const item = await ExecuteAxios.api('get', `/classification/get-classification-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }
        if (!clothesIdSelected || clothesIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setClothesIdSelected}
                    idsSelected={clothesIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('post', `/classification/`, {
                dsClassification: dsClassification,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }
            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('put', `/classification/`, {
                id: idItem,
                dsClassification: dsClassification,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Classificação produtos'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={clothesIdSelected && clothesIdSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                putFunction={putItem}
                enableNewRecord={true}
                canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={clothesIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setClothesIdSelected}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default ClothesClassification;